import React from "react";
import PropTypes from "prop-types";

const SizeFilterActions = ({ handleApplyClick, handleClearClick }) => {
  return (
    <div className="reviews_filters-size_filter-dropdown-btn-holder">
      <button
        className="reviews_filters-size_filter-dropdown-small-close-btn light_btn"
        onClick={() => handleClearClick()}>
        Clear
      </button>
      <button
        className="reviews_filters-size_filter-dropdown-small-close-btn dark_btn"
        onClick={() => handleApplyClick()}>
        Apply
      </button>
    </div>
  );
};

SizeFilterActions.propTypes = {
  handleApplyClick: PropTypes.func.isRequired,
  handleClearClick: PropTypes.func.isRequired,
};

export default SizeFilterActions;
